import { useEffect, useMemo, useState } from 'react';

import { reduce } from 'lodash/fp';

import moduleTvas from '../utils/tvas';

const useGetTvas = () => {
  const [tvas, setTVAS] = useState([]);

  const tvasById = useMemo(() => reduce((acc, val) => ({ ...acc, [val.tva_taux_id]: val }), {}, tvas), [tvas]);

  useEffect(() => {
    moduleTvas.get().then(t => setTVAS(t));
  }, []);

  return {
    tvas,
    setTVAS,
    tvasById,
  };
};

export default useGetTvas;
